import { render, staticRenderFns } from "./ResumoPagamento.vue?vue&type=template&id=5ac0f05c"
import script from "./ResumoPagamento.vue?vue&type=script&lang=js"
export * from "./ResumoPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports